// client/src/pages/ShopPOS/utils/denominations.ts

// Valores por defecto para el desglose de denominaciones
export const DEFAULT_DENOMINATIONS: Record<string, number> = {
  "5000": 0,
  "2000": 0,
  "1000": 0,
  "500": 0,
  "200": 0,
  "100": 0,
  "50": 0,
  "20": 0,
  "10": 0,
  "5": 0,
  "3": 0,
  "1": 0,
  coins: 0,
};

// Calcular total a partir del desglose de denominaciones
export const calculateTotalFromDenominations = (
  denominations: Record<string, number>,
): number => {
  let total = 0;
  total += (denominations["5000"] || 0) * 5000;
  total += (denominations["2000"] || 0) * 2000;
  total += (denominations["1000"] || 0) * 1000;
  total += (denominations["500"] || 0) * 500;
  total += (denominations["200"] || 0) * 200;
  total += (denominations["100"] || 0) * 100;
  total += (denominations["50"] || 0) * 50;
  total += (denominations["20"] || 0) * 20;
  total += (denominations["10"] || 0) * 10;
  total += (denominations["5"] || 0) * 5;
  total += (denominations["3"] || 0) * 3;
  total += (denominations["1"] || 0) * 1;
  total += denominations["coins"] || 0;
  return total;
};

// Resetear denominaciones a valores por defecto
export const resetDenominations = (): Record<string, number> => {
  return { ...DEFAULT_DENOMINATIONS };
};
